import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background-50 px-4 text-center">
      <h1 className="text-6xl md:text-8xl font-heading font-bold text-primary-500 mb-4">404</h1>
      <p className="text-xl text-foreground-300 mb-2">页面未找到</p>
      <p className="text-sm text-foreground-500 mb-8">您访问的页面不存在或已被移除</p>
      <Link
        to="/"
        className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-950 font-medium rounded-full text-sm transition-colors whitespace-nowrap cursor-pointer"
      >
        返回首页
      </Link>
    </div>
  );
}